import React from 'react';
import LocationTemplate from './LocationTemplate';

const CalypsoPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Calypso"
      stateName="North Carolina"
      countyName="Duplin"
      zipCodes={["28325"]}
      latitude={35.1579}
      longitude={-78.1137}
      population={410}
      historicalFact="Incorporated in 1913, known for pickle production."
      nearbyTowns={[
        "Mount Olive, NC",
        "Warsaw, NC",
        "Faison, NC",
        "Turkey, NC",
        "Seven Springs, NC",
        "Pink Hill, NC",
        "Goldsboro, NC",
        "Kenansville, NC"
      ]}
    />
  );
};

export default CalypsoPage;